export default "__VITE_ASSET__BuRun3gO__"